import template from './subscription.html';
import controller from './subscription.controller';
import './subscription.scss';

let SubscriptionComponent = {
  bindings: {
    pointOfSalesUnitPrice: '<',
    spinPadUnitPrice: '<'
  },
  template,
  controller
};

export default SubscriptionComponent;



// WEBPACK FOOTER //
// ./src/app/pages/subscription/subscription.component.js